import SEO from '../../Components/SEO';
import React from 'react';
// Langage
import "../../i18n";
import { useTranslation } from 'react-i18next';

function About() {
  const { t } = useTranslation();
  return (
    <div className='w-full min-h-screen p-4 max-w-5xl  mx-auto flex flex-col items-start justify-center'>
      <SEO
        title={t('about_title') || 'À propos'}
        description={t('about_meta') || 'Qui sommes-nous ? Découvrez notre mission et notre équipe.'}
        canonical={'https://safaridew.vercel.app/About'}
      />
      <h3 className='py-4 text-3xl'> {t("we_are_a")} </h3>
      <p>
        {t("about_desc1")}
        <br /> <br />
        {t("about_desc2")}
      </p>
    </div>
  );
}

export default About;
